module.exports = __webpack_public_path__ + "img/overlay-invite-user.56521e2e.svg";